/* eslint-disable react/jsx-no-bind */
import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';

const LoginButtons = (props) => { 
    const Login = () => {
        props.history.push('/Account/Login');
    };
    const Signup = () => {
        props.history.push(`/Account/Signup${landing ? '?landing=True' : ''}`);
    };

    const landing = props.location.pathname === "/Intro";

    return (
        <div className={`logbutts ${landing ? 'signonly' : '' }`}>
            {
                !landing ?
                    <button onClick={Login} className={`btn ${props.sideMenu ? 'btn-primary btn-dark' : 'btn-outline'} btn-login transition`} style={{ marginRight: props.sideMenu ? '0' : '3px' }}>LOG IN</button> 
                : 
                    null
            }
            <button onClick={Signup} className={`btn ${landing || props.sideMenu ? 'btn-primary' : 'btn-white'} btn-signup transition`}>SIGN UP</button>
            
            
        </div>
    );
};

LoginButtons.propTypes = {
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    sideMenu: PropTypes.bool
};

export default withRouter(LoginButtons);